import * as SharedPackage from './exports';
import './npmRun';

export * from './exports';
export { default as version } from './version';
export default 1;

if (typeof global !== 'undefined') global.SharedPackage = SharedPackage;
if (typeof window !== 'undefined') window.SharedPackage = SharedPackage;
